export default "__VITE_ASSET__BO_Dwru2__"